import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import React, { useState, useEffect } from 'react';
import { BagXFill, BagDash, BagPlus } from 'react-bootstrap-icons';

import { Star, StarFill, StarHalf} from 'react-bootstrap-icons';
import StarRatingBlock from '../blocks/StarRating';

/* UI Stuff */
import LoadingAnimation from '../UIComponents/LoadingAnimation';
/*  */
import ImageContainer from '../blocks/UIImageContainer';
import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';
import { INTRFItem } from '../../hooks/Interfaces';

interface StoreItemProps {
    item: INTRFItem;
    appupdate: () => void;
}

function StoreItem({item,appupdate}: StoreItemProps){

    const [loading, setLoading] = useState(true);
    const [count, setCount] = useState(0);
    const [quickshop, setQuickShop] = useState(false);

    const incCount = (event: React.MouseEvent) => {
        setCount(count + 1);
    }
    const decCount = (event: React.MouseEvent) => {
        setCount(count - 1);
    }

    const toggleQuickShop = (event: React.MouseEvent) => {
        if (quickshop){
            setQuickShop(false);
        }else{
            setQuickShop(true);
        }
    }
    /* Component Init */

    const axiosConfig = GetHeaders();

    useEffect(() => {
        console.log("Initializing cart component.")

        if (count < 0) setCount(0);
        setLoading(false)
    }, [count, quickshop]);

    const addToCart = async (event: React.MouseEvent) => {
        event.preventDefault();
        setLoading(true);
        let iteminfo = {
            'product_id': item.itemid,
            'count': count
        }
        let posturl = process.env.REACT_APP_API_URL + "/v1/commerce/cart/update";
        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: iteminfo})

        //Handle a Non 200 response
        appupdate();
        setLoading(false);

        setCount(0);
        setQuickShop(false);
    }

    return (
        <> 
            <div className="">

                <Container fluid className="border rounded pb-1 brand-primary-color">
                    <a href={'/inventory/item/' + item.itemid}>
                        <Row className="generic-bottom-border brand-primary-color-border position-relative">
                            
                            <div className="square-image-block bg-white">
                                {loading ? <LoadingAnimation /> : <ImageContainer img_url={item.image} /> }
                            </div>
                            <div className="position-absolute bottom-0 end-0 text-font-size-small bg-white opacity-75">
                                <p className="p-0 m-0 brand-tertiary-font-color">{item.name}</p>
                            </div>
                        </Row>
                    </a>
                    <Row>
                        <Col>
                            { item.size &&
                            <div className="text-start text-font-light">
                                { (item.size >= 1000) ? <p>{(item.size/1000)}L</p> : <p>{item.size}ML</p> }
                            </div>
                            }
                        </Col>
                        <Col><div className="text-end text-font-light"><p>${item.price.toFixed(2)}</p></div></Col>
                    </Row>
                    <Row  className="px-1">
                            { !quickshop && 
                                <Col className="" xs={{span: 12}}>
                                    <button type="button" className="btn brand-btn-tertiary-color input-fill py-0" onClick={(e) => toggleQuickShop(e)}>
                                        Add to Cart
                                    </button>
                                </Col>
                            }
                            { quickshop && 
                                <Col className="p-0" xs={{span: 2}}>
                                    <button type="button" className="btn brand-btn-tertiary-color input-fill py-0" onClick={(e) => toggleQuickShop(e)}>
                                        X
                                    </button>
                                </Col>
                            }
                    </Row>
                    { quickshop && 
                    <>
                        <Row className="px-1">
                            <Col className="p-0 py-3">
                                <button type="button" className="btn brand-btn-tertiary-color input-fill" onClick={(e) => incCount(e)}>
                                    <BagPlus size={32} />
                                </button>
                            </Col>
                            <Col className="p-0 py-3">
                                <input type="text" className="btn input-fill" value={count} />
                            </Col>
                            <Col className="p-0 py-3">
                                <button type="button" className="btn brand-btn-tertiary-color input-fill" onClick={(e) => decCount(e)}>
                                    <BagDash size={32} />
                                </button>
                            </Col>
                        </Row>
                        
                        <Row className="text-light text-font-medium text-center px-1">
                        <button type="button" className="btn brand-btn-secondary-color input-fill py-0" onClick={(e) => addToCart(e)}>Add to Cart</button>
                        </Row>
                    </>
                    }

                </Container>
            </div>
        </>
    )
}

export default StoreItem;